  <template>
    <v-card>
      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">New Expense</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="addExpenseCheck($v.currentExpense)">
          <v-icon color="green">fas fa-check</v-icon>
        </v-btn>
        <v-btn icon @click.native="$router.push({ path: '/dashboard/expense' })">
          <v-icon color="red">fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text style="padding-top: 0;">
        <v-container grid-list-md v-bind:class="{'padContent': !drawer}">
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete v-bind:items="curriencies"
                              v-model="currentExpense.currency"
                              label="Currency"
                              chips
                              hint="What Currency is this Expense in?"
                              persistent-hint
                              :error-messages="currencyErrors"
                              @input="$v.currentExpense.currency.$touch(), adjustCurrency()"
                              @blur="$v.currentExpense.currency.$touch()"></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Expense Name" v-model="currentExpense.expenseName"
                            :error-messages="expenseNameErrors"
                            clearable
                            @input="$v.currentExpense.expenseName.$touch()"
                            @blur="$v.currentExpense.expenseName.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete v-bind:items="account"
                              v-model="currentExpense.account"
                              label="Account"
                              chips
                              prepend-icon="fa-balance-scale"
                              hint="What Account does this belong to?"
                              persistent-hint
                              :error-messages="accountErrors"
                              @change="clearBudgetOnAccountChange"
                              @input="$v.currentExpense.account.$touch(), adjustCurrency(), clearBudgetOnAccountChange()"
                              @blur="$v.currentExpense.account.$touch()"></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete v-bind:items="budget"
                              v-model="currentExpense.budget"
                              label="Budget"
                              chips
                              prepend-icon="fas fa-calculator"
                              hint="What Budget does this belong to?"
                              persistent-hint
                              :error-messages="budgetErrors"
                              @change="adjustAccountToMatchBudgetOnBudgetChange"
                              @input="$v.currentExpense.budget.$touch(); adjustAccountToMatchBudgetOnBudgetChange()"
                              @blur="$v.currentExpense.budget.$touch()"></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete v-bind:items="category"
                              v-model="currentExpense.category"
                              label="Category"
                              chips
                              prepend-icon="fa-tag"
                              hint="What Category does this belong to?"
                              persistent-hint
                              :error-messages="categoryErrors"
                              @input="$v.currentExpense.category.$touch()"
                              @blur="$v.currentExpense.category.$touch()"></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <Items v-bind:itype="'expense'" v-on:ItemToAdd="addItemToExpense($event)"></Items>
              <!--<v-expansion-panel popout>
                <v-expansion-panel-content>
                  <div slot="header"><b>Items</b></div>
                  <v-card>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs8>
                          <v-text-field append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        v-model="expenseItemsSearch"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-tooltip bottom>
                            <v-btn v-on:click.prevent="addItem = true"
                                   slot="activator"
                                   small
                                   fab
                                   middle
                                   right
                                   style="float:right;">
                              <v-icon>fas fa-plus</v-icon>
                            </v-btn>
                            <span>Add Item</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      <v-divider></v-divider>
                      <v-data-table :headers="expenseItemheaders"
                                    :items="currentExpense.items"
                                    hide-actions
                                    item-key="itemName"
                                    :search="expenseItemsSearch">
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded">
                            <td>{{ props.item.itemName }}</td>
                            <td>{{ props.item.itemPrice }}</td>
                          </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          No results found for search "{{ expenseItemsSearch }}" .
                        </v-alert>
                        <template slot="expand" slot-scope="props">
                          <v-card flat>
                            <v-divider></v-divider>
                            <v-layout>
                              <v-flex xs6><v-btn color="warning" v-on:click.prevent="EditItem(props.item)"><v-icon style="font-size:18px; padding-right: 5px;">fa-edit</v-icon>Edit</v-btn></v-flex>
                              <v-flex xs6><v-btn color="error" v-on:click.prevent="DeleteItem(props.item)"><v-icon style="font-size:18px; padding-right: 5px;">fa-trash</v-icon>Delete</v-btn></v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <table style="width: 100%;">
                              <tr>
                                <td><v-subheader>Currency:</v-subheader></td>
                                <td><v-subheader>{{ props.item.itemCurrency }}</v-subheader></td>
                              </tr>
                              <tr>
                                <td><v-subheader>Category:</v-subheader></td>
                                <td><v-subheader>{{  }}</v-subheader></td>
                              </tr>
                              <tr v-if="props.item.isTaxed">
                                <td><v-subheader>Total With Tax:</v-subheader></td>
                                <td><v-subheader>{{ props.item.taxedPrice }}</v-subheader></td>
                              </tr>

                            </table>
                           
                          </v-card>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>-->
            </v-flex>
            <v-flex xs12 v-if="conversion">
              <v-text-field label="Currency Conversion"
                            prepend-icon="fas fa-balance-scale"
                            v-model="currentExpense.currencyConversion.conversionRate"
                            @click.prevent="getCurrencyConvertionRate()"
                            @focus="getCurrencyConvertionRate()"
                            :error-messages="currencyConversionErrors"
                            @input="$v.currentExpense.currencyConversion.$touch()"
                            @blur="$v.currentExpense.currencyConversion.$touch()"></v-text-field>
              <CurrencyConverter ref="converter" v-on:conversionRate="setCurrencyConversionRate($event)"></CurrencyConverter>
            </v-flex>
            <v-flex xs12 v-if="conversion">
              <v-text-field label="Amount" prepend-icon="fas fa-money-bill" type="number" min="1"
                            v-model="currentExpense.foreignCurrencyAmount"
                            :error-messages="foreignCurrencyAmountErrors"
                            @input="$v.currentExpense.foreignCurrencyAmount.$touch(), calculateConvertedAmount()"
                            @blur="$v.currentExpense.foreignCurrencyAmount.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="!conversion">
              <v-text-field label="Expense Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                            v-model="currentExpense.expenseAmount"
                            :error-messages="expenseAmountErrors"
                            @input="$v.currentExpense.expenseAmount.$touch()"
                            @blur="$v.currentExpense.expenseAmount.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="conversion">
              <v-text-field label="Converted Amount" prepend-icon="fa-money-bill-alt"
                            v-model="currentExpense.expenseAmount"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Comment" prepend-icon="fa-comment" clearable v-model="currentExpense.comment"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-switch v-model="recurringExpense"
                        label="Recurring Expense"></v-switch>
            </v-flex>
            <v-flex xs6 v-if="!recurringExpense">
              <v-dialog ref="dialog"
                        persistent
                        lazy
                        v-model="addModelExpenseDate"
                        full-width
                        width="290px"
                        :return-value.sync="currentExpense.expenseDate">
                <v-text-field slot="activator"
                              label="Expense Date"
                              v-model="currentExpense.expenseDate"
                              prepend-icon="event"
                              :error-messages="expenseDateErrors"
                              @input="$v.currentExpense.expenseDate.$touch()"
                              @blur="$v.currentExpense.expenseDate.$touch()"
                              readonly></v-text-field>
                <v-date-picker v-model="currentExpense.expenseDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="addModelExpenseDate = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(currentExpense.expenseDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6 v-if="!recurringExpense">
              <v-dialog ref="timemenu"
                        persistent
                        v-model="timemenuvisibilty"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="currentExpense.expenseTime">
                <v-text-field slot="activator"
                              label="Time Picker"
                              v-model="currentExpense.expenseTime"
                              prepend-icon="access_time"
                              readonly></v-text-field>
                <v-time-picker v-model="currentExpense.expenseTime" actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.timemenu.save(currentExpense.expenseTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs12 v-if="recurringExpense">
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field label="Repeat Every" type="number" min="1" max="60" v-model="currentExpense.repeat"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select v-model="currentExpense.cycle"
                            :items="['Day','Week','Month','Year']"></v-select>
                </v-flex>
              </v-layout>
              <v-radio-group v-model="currentExpense.period" row>
                <v-radio label="Forever" value="Forever"></v-radio>
                <v-radio label="For Number of cycles" value="For"></v-radio>
              </v-radio-group>
              <v-text-field v-if="currentExpense.period === 'For'" label="Number of cycles" type="number" min="1" max="60" v-model="currentExpense.numberOfCycles"></v-text-field>
              <v-dialog ref="goesOff"
                        persistent
                        lazy
                        v-model="addModelGoesOff"
                        full-width
                        width="290px"
                        :return-value.sync="currentExpense.goesOffFirst">
                <v-text-field slot="activator"
                              label="Start Date"
                              v-model="currentExpense.goesOffFirst"
                              prepend-icon="event"
                              readonly></v-text-field>
                <v-date-picker v-model="currentExpense.goesOffFirst" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="addModelGoesOff = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.goesOff.save(currentExpense.goesOffFirst)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

     
      <!--Error Message-->
      <v-dialog v-model="error" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline red--text"><i class="fas fa-exclamation-triangle red--text"></i> Error</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="error=false">
              <v-icon color="red">fas fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            {{errorMessage}}
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--End Of Error Message-->

    </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'
  
  import { globalFunctions } from '../../javascript/globalFunctions'
  import { accountManager } from '../../javascript/accountManager'
  import { expenseManager } from '../../javascript/expenseManager'

  import Items from '../../components/reuseable/items/Items.vue'
  import currencyConverter from '../../components/reuseable/currencyConverter/currencyConverter.vue'

  export default {
    mixins: [validationMixin],
    components: {
      'CurrencyConverter': currencyConverter,
      'Items': Items
    },
    props: ['drawer'],
    data() {
      return {
        error: false,
        errorMessage: '',
        account: [],
        budget: ["None"],
        category: ["cat"],
        curriencies: ["USD", "JMD"],
        OneTime: false,
        Recurring: false,
        type: 'OneTime',
        //addItem: false,
        //expenseItemheaders: [
        //  { text: 'Item', align: 'left', value: 'itemName' },
        //  { text: 'Price', align: 'left', value: 'itemPrice' }
        //],
        //expenseItems: [],
        //expenseItemsNames: ['Cat', 'Dog'],
        //expenseItemsSearch: '',
        conversion: false,
        recurringExpense: false,
        sameExpense: false,
        addModelExpenseDate: false,
        addModelGoesOff: false,
        timemenuvisibilty: false,
        conversions: [],
        //expenseItemTemp: {
        //  itemName: [],
        //  itemPrice: '',
        //  itemCurrency: '',
        //  isTaxed: false,
        //  taxedPrice: '',

        //  dateChanged: ''
        //},
        currentExpense: {
          id: 0,
          expenseName: '',
          account: '',
          budget: 'None',
          expenseType: '',
          foreignCurrencyAmount: 0,
          expenseAmount: 0,
          currencyConversion: {},
          currency: '',
          expenseDate: '',
          expenseTime: '',
          comment: '',
          category: '',

          items: [],

          //Recurring
          repeat: 1,
          cycle: '',
          period: 'Forever',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: 'New',
          show: false
        },
        items:[]
      }
    },
    computed: {
      expenseNameErrors() {
        const errors = []
        if (!this.$v.currentExpense.expenseName.$dirty) return errors
        this.sameExpense && errors.push('A Expense already has this Name. Enter a new Name of update Expense')
        !this.$v.currentExpense.expenseName.required && errors.push('Expense Name is required')
        return errors
      },
      accountErrors() {
        const errors = []
        if (!this.$v.currentExpense.account.$dirty) return errors
        !this.$v.currentExpense.account.required && errors.push('Account is required')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.currentExpense.currency.$dirty) return errors
        !this.$v.currentExpense.currency.required && errors.push('Currency is required')
        return errors
      },
      currencyConversionErrors() {
        const errors = []
        if (!this.$v.currentExpense.currencyConversion.$dirty) return errors
        !this.$v.currentExpense.currencyConversion.required && errors.push('Currency Conversion is required')
        return errors
      },
      budgetErrors() {
        const errors = []
        if (!this.$v.currentExpense.budget.$dirty) return errors
        !this.$v.currentExpense.budget.required && errors.push('Budget is required')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.currentExpense.category.$dirty) return errors
        !this.$v.currentExpense.category.required && errors.push('Category is required')
        return errors
      },
      foreignCurrencyAmountErrors() {
        const errors = []
        if (!this.$v.currentExpense.foreignCurrencyAmount.$dirty && !this.$v.currentExpense.foreignCurrencyAmount.$dirty) return errors
        !this.$v.currentExpense.foreignCurrencyAmount.minValue && !this.$v.currentExpense.foreignCurrencyAmount.minValue && errors.push('Amount must be at least 1')
        return errors
      },
      expenseAmountErrors() {
        const errors = []
        if (!this.$v.currentExpense.expenseAmount.$dirty) return errors
        !this.$v.currentExpense.expenseAmount.minValue && errors.push('Expense Amount must be at least 1')
        return errors
      },
      expenseDateErrors() {
        const errors = []
        if (!this.$v.currentExpense.expenseDate.$dirty) return errors
        !this.$v.currentExpense.expenseDate && errors.push('Expense Date is required')
        return errors
      }
      
    },
    methods: {
      adjustCurrency: function () {
        if (this.currentExpense.account !== '') {
          let acc = accountManager.getAccountByName(this.currentExpense.account)

          if (this.currentExpense.currency === '') {
            this.currentExpense.currency = acc.accountCurrency
          }
          else if (this.currentExpense.currency !== acc.accountCurrency) {
            this.conversion = true
          }
        }
      },
      getCurrencyConvertionRate: function () {
        this.$refs.converter.showConverter()

        let acc = accountManager.getAccountByName(this.currentExpense.account)

        this.$refs.converter.getcurrencyData(this.currentExpense.currency, acc.accountCurrency)
      },
      setCurrencyConversionRate: function (data) {
        this.currentExpense.currencyConversion = data
      },
      updateDateAndTime: function () {
        this.currentExpense.expenseDate = globalFunctions.getCurrentDateForPicker()
        this.currentExpense.expenseTime = globalFunctions.getCurrentTimeForPicker()
      },
      expenseCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.currentExpense.expenseAmount <= 0 || !globalFunctions.isIntOrFloat(this.currentExpense.expenseAmount) || this.currentExpense.expenseAmount === "") { this.currentExpense.expenseAmount = 0 }

        if ($v.expenseName.$invalid || $v.category.$invalid || $v.account.$invalid) {
          return false
        }

        if (!this.checkAmountIfGreaterThanAccountOrBudget()) { return false }

        if (this.recurringExpense) {
          this.currentExpense.expenseType = "Recurring"
        } else if (!this.recurringExpense) {
          this.currentExpense.expenseType = "OneTime"
        }

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].expenseName.toLowerCase() === this.currentExpense.expenseName.toLowerCase() && this.items[i].objectState !== 'Delete') {
            this.sameExpense = true
            return false
          }
          if (i === this.items.length - 1) {
            this.sameExpense = false
          }
        }

        return true
      },
      addExpenseCheck: function ($v) {
        if (this.expenseCheck($v)) {
          this.addExpense();
        }
      },
      addExpense: function () {
        expenseManager.addExpense(this.currentExpense)

        this.createTransactionIfNeeded()

        this.$router.push({ path: '/dashboard/expense' })
      },
      //getLargestIdFromItems: function () {
      //  let largest = 0
      //  for (let i = 0; i < this.items.length; i++) {
      //    if (this.items[i].id > largest) {
      //      largest = this.items[i].id
      //    }
      //  }
      //  return largest
      //},
      adjustAccountToMatchBudgetOnBudgetChange: function() {
        if (this.currentExpense.budget !== 'None') {
          let bud = this.$store.state.Budgets
          for (let i = 0; i < bud.length; i++) {
            if (bud[i].budgetName === this.currentExpense.budget) {
              this.currentExpense.account = bud[i].account
            }
          }
        }
      },
      clearBudgetOnAccountChange: function() {
        this.currentExpense.budget = 'None'
      },
      checkAmountIfGreaterThanAccountOrBudget: function () {
        let amount = this.getAmountForBudgetOrAccount()

        if (parseInt(this.currentExpense.expenseAmount) > parseInt(amount)) {

          //Show Error Message
          this.error = true
          this.errorMessage = "Cannot Add An Expense Greater Than Account/ Budget Amount"

          return false
        }
        return true
      },
      getAmountForBudgetOrAccount: function () {
        if (this.currentExpense.budget === 'None') {
          return globalFunctions.getAccountCurrentAmount(this.currentExpense.account, this.$store.state.Accounts)
        }
        else if (this.currentExpense.budget !== 'None') {
          return globalFunctions.getBudgetCurrentAmount(this.currentExpense.budget, this.$store.state.Budgets)
        }
      },
      createTransactionIfNeeded: function () {
        if (this.checkIfTransactionIsNeeded) {
          expenseManager.createTransactionFromExpense(this.currentExpense)
        }
      },
      checkIfTransactionIsNeeded: function () {
        let today = new Date()
        let expenseTime = new Date(this.currentExpense.expenseDate)

        if (today.getTime() === expenseTime.getTime()) {
          return true
        }

        return false
      },
      calculateConvertedAmount: function () {
        if (this.currentExpense.foreignCurrencyAmount !== 0 && this.currentExpense.foreignCurrencyAmount !== '' && this.currentExpense.currencyConversion.conversionRate !== '') {
          this.currentExpense.expenseAmount = parseFloat(this.currentExpense.foreignCurrencyAmount) * parseFloat(this.currentExpense.currencyConversion.conversionRate)
        }
        else {
          this.currentExpense.expenseAmount = 0
        }
      },
      addItemToExpense(item) {
        if (this.currentExpense.items.length === 0) {
          this.currentExpense.items.push(item)

          this.addItemPriceToExpenseAmount()
        }
        else {
          for (let i = 0; i < this.currentExpense.items.length; i++) {
            if (this.currentExpense.items[i].id === item.id) {

              this.updateExpenseAmount(this.currentExpense.items[i], item)
              this.currentExpense.items[i] = JSON.parse(JSON.stringify(item))
              break
            }

            if (i === this.currentExpense.items.length - 1) {
              this.currentExpense.items.push(item)
              this.addItemPriceToExpenseAmount()
              break
            }
          }
        }
      },
      updateExpenseAmount: function (olditem, newitem) {
        this.currentExpense.expenseAmount = parseFloat(this.currentExpense.expenseAmount) - parseFloat(this.currencyConverter(olditem))

        this.currentExpense.expenseAmount = parseFloat(this.currentExpense.expenseAmount) + parseFloat(this.currencyConverter(newitem))
      },
      addItemPriceToExpenseAmount: function () {

        let total = 0;
        for (let i = 0; i < this.currentExpense.items.length; i++) {
          total = parseFloat(total) + parseFloat(this.currencyConverter(this.currentExpense.items[i]))
        }

        this.currentExpense.expenseAmount = total

      },
      currencyConverter: function (item) {
        ////////////////////////////////////////////////////////////////////
        //Returns Price If Currencies Are The Same,
        //Returns Adjusted Price If Currency Is Different
        ////////////////////////////////////////////////////////////////////

        if (item.itemCurrency === this.currentExpense.currency || this.currentExpense.currency === "") {
          return item.itemPrice
        } else {
          for (let i = 0; i < this.conversions.length; i++) {
            if (this.conversions.convertFrom === item.itemCurrency) {
              return parseFloat(this.conversions.conversionRate) * item.itemPrice
            }
          }
        }

      }
    },
    watch: {
      "currentExpense.currencyConversion": function () {
        this.calculateConvertedAmount()
      }
    },
    beforeMount() {

      this.items = this.$store.state.Expenses

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let acc = this.$store.state.Accounts
      for (let i = 0; i < acc.length; i++) {
        this.account.push(acc[i].accountName)
      }

      let curCon = this.$store.state.CurrencyConversions
      for (let i = 0; i < curCon.length; i++) {
        this.currencyConversions.push(curCon[i])
      }

      let bud = this.$store.state.Budgets
      for (let i = 0; i < bud.length; i++) {
        this.budget.push(bud[i].budgetName)
      }

      this.updateDateAndTime()
    },
    validations: {
      currentExpense: {
        expenseName: {
          required
        },
        account: {
          required
        },
        currency: {
          required
        },
        currencyConversion: {
          required
        },
        budget: {
          required
        },
        category: {
          required
        },
        foreignCurrencyAmount: {
          required,
          minValue: minValue(1)
        },
        expenseAmount: {
          required,
          minValue: minValue(1)
        },
        expenseDate: {
          required
        }
      },
      //expenseItemTemp: {
      //  itemName: {
      //    required
      //  },
      //  itemPrice: {
      //    required,
      //    minValue: minValue(1)
      //  },
      //  itemCurrency: {
      //    required
      //  }

      //}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/expense/AddExpenses.vue